export const genericAppIndexId = '9d18c582-61eb-4764-a60c-244c7e6ea1c2';
